import * as React from 'react';
import { SVGIconRender } from './SVGIconRender';

interface IconProps {
  color?: string;
  size?: string;
  bgFillColor?: string;
}

const QuoteModule = ({ color = 'black', bgFillColor = 'black', size = 'md' }: IconProps) => {
  return (
    <SVGIconRender
          size={size}
          color={color}
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M4 4.00007C4 2.73771 5.02335 1.71436 6.28571 1.71436H14.2857C17.4416 1.71436 20 4.27273 20 7.42864V20.0001C20 21.2624 18.9767 22.2858 17.7143 22.2858H6.28571C5.02335 22.2858 4 21.2624 4 20.0001V4.00007Z"
            fill="url(#paint0_linear_123_14390)"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M8.5999 14.2864C8.90405 14.3015 9.14286 14.5526 9.14286 14.8571V15.9999C9.14286 16.3155 9.3987 16.5714 9.71429 16.5714H11.4286C11.7442 16.5714 12 16.8272 12 17.1428C12 17.4584 11.7442 17.7142 11.4286 17.7142H9.71429C9.40854 17.7142 9.12149 17.6342 8.87294 17.4939C8.57804 18.952 6.59368 19.3382 5.79572 18.0082C5.63335 17.7376 5.7211 17.3866 5.99172 17.2242C6.26234 17.0619 6.61334 17.1496 6.77571 17.4202C7.03968 17.8602 7.7119 17.7096 7.76295 17.1991L8.00284 14.8002C8.03314 14.4972 8.29575 14.2712 8.5999 14.2864Z"
            fill="#551A61"
          />
          <rect
            x="13.1429"
            y="9.71436"
            width="4.57143"
            height="1.14286"
            rx="0.571429"
            fill="#551A61"
          />
          <rect
            x="13.1429"
            y="13.1428"
            width="4.57143"
            height="1"
            rx="0.5"
            fill="#551A61"
          />
          <rect
            x="13.1429"
            y="16.5715"
            width="4.57143"
            height="1"
            rx="0.5"
            fill="#551A61"
          />
          <rect
            x="13.1429"
            y="6.28564"
            width="4.57143"
            height="1.14286"
            rx="0.571429"
            fill="#551A61"
          />
          <path
            d="M20 7.15636C20 7.30664 19.8782 7.42847 19.7279 7.42847L16.5714 7.42847C15.3091 7.42847 14.2857 6.40512 14.2857 5.14275L14.2857 1.98629C14.2857 1.83601 14.4075 1.71418 14.5578 1.71418C17.5635 1.71418 20 4.15073 20 7.15636Z"
            fill="url(#paint1_linear_123_14390)"
          />
          <path
            d="M8.53143 5.84C7.86773 5.85778 7.53587 6.08296 7.53587 6.51556C7.53587 6.92444 7.8618 7.21185 8.51365 7.37778L8.52254 7.38667C8.52847 7.38667 8.53439 7.38667 8.54032 7.38667C8.5581 7.39259 8.57291 7.38963 8.58476 7.37778C8.59661 7.36 8.60254 7.34222 8.60254 7.32444V5.92C8.60254 5.86667 8.57884 5.84 8.53143 5.84ZM8.62921 10.1511C9.26328 10.1096 9.58032 9.85185 9.58032 9.37778C9.58032 9.15852 9.50921 8.97778 9.36699 8.83556C9.22476 8.69333 8.97587 8.57185 8.62032 8.47111C8.57291 8.45926 8.54921 8.47704 8.54921 8.52445V10.08C8.54921 10.1274 8.57587 10.1511 8.62921 10.1511ZM7.66921 8.16C6.80402 7.78667 6.37143 7.23852 6.37143 6.51556C6.37143 6.01778 6.55217 5.6237 6.91365 5.33333C7.28106 5.04296 7.82032 4.89481 8.53143 4.88889C8.57884 4.88889 8.60254 4.86222 8.60254 4.80889V4.44444C8.60254 4.32 8.64402 4.2163 8.72699 4.13333C8.81587 4.04444 8.92254 4 9.04699 4C9.17143 4 9.27513 4.04444 9.3581 4.13333C9.44699 4.2163 9.49143 4.32 9.49143 4.44444V4.87111C9.49143 4.91259 9.51513 4.93926 9.56254 4.95111C9.72847 4.96889 9.89143 4.99556 10.0514 5.03111C10.1996 5.06074 10.3181 5.13482 10.407 5.25333C10.5018 5.37185 10.5492 5.50815 10.5492 5.66222V5.68889C10.5492 5.81333 10.4988 5.91111 10.3981 5.98222C10.3033 6.04741 10.1937 6.06519 10.0692 6.03556C9.89736 5.98815 9.72847 5.95259 9.56254 5.92889C9.51513 5.91704 9.49143 5.93778 9.49143 5.99111V7.55556V7.6C9.47958 7.64741 9.49736 7.68296 9.54476 7.70667C9.98921 7.8963 10.3033 8.12148 10.487 8.38222C10.6766 8.64296 10.7714 8.96889 10.7714 9.36C10.7714 9.89926 10.5877 10.32 10.2203 10.6222C9.85884 10.9185 9.32254 11.0785 8.61143 11.1022C8.56995 11.1022 8.54921 11.1289 8.54921 11.1822V11.5556C8.54921 11.68 8.50476 11.7837 8.41587 11.8667C8.33291 11.9556 8.22921 12 8.10476 12C7.98032 12 7.87365 11.9556 7.78476 11.8667C7.7018 11.7837 7.66032 11.68 7.66032 11.5556V11.1378C7.66032 11.0904 7.63069 11.0607 7.57143 11.0489C7.39958 11.0252 7.20995 10.9837 7.00254 10.9244C6.86032 10.883 6.74476 10.8 6.65587 10.6756C6.57291 10.5452 6.53143 10.403 6.53143 10.2489V10.1778C6.53143 10.0652 6.57884 9.9763 6.67365 9.91111C6.77439 9.84593 6.8781 9.83704 6.98476 9.88444C7.18624 9.96741 7.38476 10.0296 7.58032 10.0711C7.5981 10.077 7.61587 10.0741 7.63365 10.0622C7.65143 10.0444 7.66032 10.0267 7.66032 10.0089V8.44444C7.66032 8.36741 7.67217 8.30519 7.69587 8.25778C7.71958 8.21037 7.71069 8.17778 7.66921 8.16Z"
            fill="#551A61"
          />
          <defs>
            <linearGradient
              id="paint0_linear_123_14390"
              x1="12"
              y1="1.71436"
              x2="12"
              y2="22.2858"
              gradientUnits="userSpaceOnUse"
            >
              <stop stop-color="#FFB4B6" />
              <stop offset="1" stop-color="#D56BEE" />
            </linearGradient>
            <linearGradient
              id="paint1_linear_123_14390"
              x1="25.7143"
              y1="-5.14296"
              x2="14.2857"
              y2="7.42847"
              gradientUnits="userSpaceOnUse"
            >
              <stop stop-color="#FFACB0" />
              <stop offset="1" stop-color="#D66DED" />
            </linearGradient>
          </defs>
        </SVGIconRender>
  );
};

export default QuoteModule;
